var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconGoto = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#264D6D",
    fillRule: "nonzero",
    d: "M10.818 23.82a.82.82 0 0 0 .818-.818v-3.273a.82.82 0 0 1 .819-.818h12.75l-1.877 1.878a.82.82 0 0 0 0 1.158.845.845 0 0 0 .581.237.815.815 0 0 0 .577-.242l3.273-3.272c.012-.013.02-.025.032-.041a.435.435 0 0 0 .037-.045.673.673 0 0 0 .107-.18s0-.004.004-.004a.783.783 0 0 0 .053-.209c.004-.016.004-.033.004-.049a.745.745 0 0 0-.082-.409l-.024-.045a.893.893 0 0 0-.131-.176l-3.273-3.273a.82.82 0 0 0-1.158 1.158l1.878 1.878H12.455A2.456 2.456 0 0 0 10 19.729v3.273c0 .45.368.818.818.818Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h38v38H0z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGoto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-goto.cb712c64.svg";
export { ForwardRef as ReactComponent };